import { setTransform, setClip } from './svg';
import { sortDom, moveTo } from './dom';
export function drawChildren(context, children) {
    children.forEach(function (child) {
        child.draw(context);
    });
}
/**
 * æ´æ°åç´ ï¼åæ¬ group å shape
 * @param {IElement} element       SVG åç´ 
 * @param {ChangeType} changeType  æ´æ°ç±»å
 */
export function refreshElement(element, changeType) {
    // å¯¹äºè¿æ²¡ææè½½å°ç»å¸ä¸çåç´ ï¼canvas å¯è½ä¸ºç©º
    var canvas = element.get('canvas');
    // åªææè½½å°ç»å¸ä¸ï¼æå¯¹åç´ è¿è¡å®éæ¸²æ
    if (canvas && canvas.get('autoDraw')) {
        var context = canvas.get('context');
        var parent_1 = element.getParent();
        var parentChildren = parent_1 ? parent_1.getChildren() : [canvas];
        var el = element.get('el');
        if (changeType === 'remove') {
            var isClipShape = element.get('isClipShape');
            // å¯¹äº clipï¼ä¸ä»éè¦å° clipShape å¯¹äºç SVG åç´ å é¤ï¼è¿éè¦å°ä¸å±ç clipPath åç´ ä¹å é¤
            if (isClipShape) {
                var clipPathEl = el && el.parentNode;
                var defsEl = clipPathEl && clipPathEl.parentNode;
                if (clipPathEl && defsEl) {
                    defsEl.removeChild(clipPathEl);
                }
            }
            else if (el && el.parentNode) {
                el.parentNode.removeChild(el);
            }
        }
        else if (changeType === 'show') {
            el.setAttribute('visibility', 'visible');
        }
        else if (changeType === 'hide') {
            el.setAttribute('visibility', 'hidden');
        }
        else if (changeType === 'zIndex') {
            moveTo(el, parentChildren.indexOf(element));
        }
        else if (changeType === 'sort') {
            var children_1 = element.get('children');
            if (children_1 && children_1.length) {
                sortDom(element, function (a, b) {
                    return children_1.indexOf(a) - children_1.indexOf(b) ? 1 : 0;
                });
            }
        }
        else if (changeType === 'clear') {
            // el maybe null for group
            if (el) {
                el.innerHTML = '';
            }
        }
        else if (changeType === 'matrix') {
            setTransform(element);
        }
        else if (changeType === 'clip') {
            setClip(element, context);
        }
        else if (changeType === 'attr') {
            // å·²å¨ afterAttrsChange è¿è¡äºå¤çï¼æ­¤å¤ do nothing
        }
        else if (changeType === 'add') {
            element.draw(context);
        }
    }
}
//# sourceMappingURL=draw.js.map